import BaseVariantImages from './BaseVariantImages'

const VariantImages = {
  ...BaseVariantImages,
  // Logos
  Logo: require('./img/variants/tpf/logo.png'),
  LogoPrimary: require('./img/variants/tpf/logoPrimary.png'),
  // Stores
  GooglePlay: require('./img/variants/tpf/googlePlay.svg'),
  AppStore: require('./img/variants/tpf/appStore.svg'),
  // Medias
  Medias: require('./img/variants/tpf/medias.svg'),
}

export default VariantImages
